import {MenuItemConfig} from '@features/profile/types/SideBar';
import {CircleInfo, FileText, Handset, House, Percent, Person, Star} from '@gravity-ui/icons';

export const menuItems: MenuItemConfig[] = [
    {
        id: 'PersonBtn',
        icon: Person,
        label: 'Персональные данные',
        route: 'person-info',
        pathMatch: 'person-info'
    },
    {
        id: 'AddressBtn',
        icon: House,
        label: 'Мои адреса',
        route: 'user-address',
        pathMatch: 'user-address'
    },
    {
        id: 'PriceBtn',
        icon: Percent,
        label: 'Уровень цен',
        route: 'price-level',
        pathMatch: 'price-level'
    },
    {
        id: 'FavoritePricesBtn',
        icon: Star,
        label: 'Избранные прайсы',
        route: 'favorite-prices',
        pathMatch: 'favorite-prices'
    },
    {id: 'ContactsBtn', icon: Handset, label: 'Контакты', route: 'contacts', pathMatch: 'contacts'},
    {
        id: 'ConditionRefundBtn',
        icon: CircleInfo,
        label: 'Гарантия и возврат',
        route: 'condition-refund',
        pathMatch: 'condition-refund'
    },
    {
        id: 'OfferBtn',
        icon: FileText,
        label: 'Оферта',
        route: 'offer',
        pathMatch: 'offer'
    }
];
